import React, { Component } from 'react'
import AntdModal from 'antd/lib/modal'
import isFunction from 'lodash/isFunction'

import confirmFn, { destroyFns } from './confirm'
import { mergeClassName } from '../utils'

import './modal.less'

class Modal extends Component {
  componentDidMount() {
    this.toggleBodyClass()
  }

  componentDidUpdate(preProp) {
    if (preProp.visible === this.props.visible) return
    this.toggleBodyClass()
  }

  componentWillUnmount() {
    Modal.removeBodyClass()
  }

  toggleBodyClass() {
    const { visible } = this.props

    if (visible) {
      document && (document.body instanceof HTMLElement) && document.body.classList.add('dialog-open')
    } else {
      Modal.removeBodyClass()
    }
  }

  static removeBodyClass() {
    document && (document.body instanceof HTMLElement) && document.body.classList.remove('dialog-open')
  }

  render() {
    const { className, dark, ...otherProps } = this.props

    return (
      <React.Fragment>
        <AntdModal
          okText='确认'
          cancelText='取消'
          {...otherProps}
          className={mergeClassName([className, dark ? 'dark-theme' : ''])}
          afterClose={this.handleAfterClose}
        />
      </React.Fragment>
    )
  }

  handleAfterClose = (...args) => {
    const { afterClose } = this.props
    Modal.removeBodyClass()
    if (isFunction(afterClose)) {
      afterClose(...args)
    }
  }
}

Modal.displayName = 'DmpModal'

Modal.info = (props) => {
  const config = {
    type: 'info',
    icon: 'info-circle',
    okCancel: false,
    ...props,
  }
  return confirmFn(config)
}

Modal.success = (props) => {
  const config = {
    type: 'success',
    icon: 'check-circle',
    okCancel: false,
    ...props,
  }
  return confirmFn(config)
}

Modal.error = (props) => {
  const config = {
    type: 'error',
    icon: 'close-circle',
    okCancel: false,
    ...props,
  }
  return confirmFn(config)
}

Modal.warn = (props) => {
  const config = {
    type: 'warning',
    icon: 'exclamation-circle',
    okCancel: false,
    ...props,
  }
  return confirmFn(config)
}

Modal.warning = Modal.warn

Modal.confirm = (props) => {
  const config = {
    type: 'confirm',
    okCancel: true,
    ...props,
  }
  return confirmFn(config)
}

Modal.open = (Element, props) => {
  const config = {
    Component: Element,
    ...props,
  }

  return confirmFn(config)
}

Modal.destroyAll = () => {
  while (destroyFns.length) {
    const close = destroyFns.pop()
    if (close) {
      close()
    }
  }
}

export default Modal
